<div
  class="toastr relative text-xs lg:text-sm bg-gray-200 flex items-start justify-between gap-4 px-4 py-3 rounded-md w-full max-w-72 min-w-60 overflow-hidden">
  <div class="line absolute inset-y-0 left-0 w-1.5 h-full"></div>
  <div class="flex items-start gap-1.5">
    <div class="icon text-white">
      @if (toastClasses.includes('success')) {
      <icon-check [size]="20" />
      } @else if (toastClasses.includes('error')) {
      <icon-error [size]="20" />
      }
    </div>
    <div class="flex flex-col gap-0.5">
      @if (title) {
      <div class="uppercase">{{ title }}</div>
      }
      @if (message) {
      <div class="lg:text-[13px] font-medium">{{ message }}</div>
      }
    </div>
  </div>
  <button type="button" class="text-white" (click)="remove()">
    <icon-close-fill [size]="17" />
  </button>
</div>